import React from 'react';
import styled from "styled-components";
import CountryControl from "./CountryControl";
import CountryControl_m from './CountryControl_m'
import addHeaders from "../../utils/addHeader";

import useApi from '../../hooks/useApi';
import { useQuery } from '@tanstack/react-query'

import { useSnapshot } from 'valtio';
import useProfile from "../../hooks/useProfile"
import FlagsPng from "./FlagsPng"

import generateSetValueObject, { resetSetValueObject } from "../select/generateSetValueObject";

const SearchBarContainer = styled.div`
    width: 100%;
    margin: 0 auto;
    position: relative;
`


const CountrySelect = React.memo(({
    name,
    valueName,
    valueId,
    valueMap,
    setValue,
    isRed,
    testId
}) => {
    const { getMe } = useApi();

    const { pState } = useProfile()
    const profile = useSnapshot(pState)
    const orgCountry = profile.currentOrgCountry

    const placeholder = `country.placeholder`

    const getData = async (key) => {
        const orgCountry = key.queryKey[1]
        const resource = `country/?country=${orgCountry}`
        const response = await getMe(resource)
        const result = addHeaders(response.data)
        return result
    }

    const returnCountry = (country, valueMap) => {
        const result = generateSetValueObject(country, valueMap)
        setValue(result);
    }

    const handleBlur = (e) => {
        if (e.target.value !== valueName) {
            const result = resetSetValueObject(valueMap)
            setValue(result);
        }
    }

    const result = useQuery({
        queryKey: ['countries', orgCountry],
        queryFn: getData,
        keepPreviousData: true,
        staleTime: 1000 * 60 * 60,
    })

    if (result.isError) {
        return <span>Error: {result.error ? result.error.message : 'Internet Issues'}</span>
    }

    return (
            <>
                <div>
                    <SearchBarContainer id='SearchBarContainer'>
                        <CountryControl
                            name={name}
                            valueName={valueName}
                            valueId={valueId}
                            setValue={setValue}
                            data={result.data}
                            placeholder={placeholder}
                            onSelect={(country) => returnCountry(country, valueMap)}
                            handleBlur={handleBlur}
                            isRed={isRed}
                            flags={FlagsPng}
                            testId={testId}
                        />
                        <CountryControl_m
                            name={name}
                            valueName={valueName}
                            valueId={valueId}
                            setValue={setValue}
                            data={result.data}
                            placeholder={placeholder}
                            onSelect={country => returnCountry(country, valueMap)}
                            isRed={isRed}
                            flags={FlagsPng}
                            testId={testId}
                        />
                    </SearchBarContainer>
                </div>
            </>
        )
});

export default CountrySelect;
